import type { AnimationSettings } from './index';

/** Animated elements start hidden and are revealed by GSAP; preview keeps them shown. */
export function animationOpacityVar(animation: AnimationSettings | undefined, isPreview: boolean): string | undefined {
    return animation?.isActive && !isPreview ? '0' : undefined;
}
